(() => {
  const SELECTOR = '[data-klampet-instagram]';
  const FEED_ROOT_MARGIN = '700px 0px';
  const FEED_IMAGE_SIZES = [
    '(min-width: 990px) 240px',
    '(min-width: 768px) calc((100vw - 60px) / 2)',
    'calc((100vw - 38px) / 2)',
  ].join(', ');

  function revealSection(section) {
    section.classList.add('is-reveal-ready');
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    observer.observe(section);
  }

  function createOverlay() {
    const overlay = document.createElement('span');
    overlay.className = 'klampet-instagram-card__overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = `
      <svg viewBox="0 0 24 24" focusable="false">
        <rect x="3" y="3" width="18" height="18" rx="5"></rect>
        <circle cx="12" cy="12" r="4"></circle>
        <circle cx="17.5" cy="6.5" r="1" class="klampet-instagram-card__icon-dot"></circle>
      </svg>
      <span>View on Instagram</span>
    `;
    return overlay;
  }

  function enhanceFeed(section) {
    const feed = section.querySelector('[data-klampet-instagram-feed]');
    const status = section.querySelector('[data-klampet-instagram-status]');
    if (!feed) return false;

    const images = Array.from(feed.querySelectorAll('img'));
    const cards = [];

    images.forEach((image) => {
      const link = image.closest('a[href]');
      if (!link || !/instagram\.com/i.test(link.href)) return;

      const card = link.closest('.instafeed-new-layout-item, .instafeed-container, .instafeed-item, article, li') || link;
      if (!cards.includes(card)) cards.push(card);
    });

    if (!cards.length) return false;

    cards.forEach((card, index) => {
      if (index > 4) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        return;
      }

      const image = card.querySelector('img');
      const link = image && image.closest('a[href]');
      if (!image || !link) return;

      card.classList.add('klampet-instagram-card');
      link.classList.add('klampet-instagram-card__link');
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', `View KlamPet Instagram post ${index + 1} (opens in a new tab)`);
      image.classList.add('klampet-instagram-card__image');
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 640;
      image.height = 640;
      image.sizes = FEED_IMAGE_SIZES;
      image.removeAttribute('fetchpriority');

      if (!link.querySelector('.klampet-instagram-card__overlay')) {
        link.appendChild(createOverlay());
      }
    });

    feed.classList.add('is-ready');
    // The provider's resize handler only runs when this ID exists. Remove it
    // after the first render so responsive CSS changes do not refetch the feed.
    feed.removeAttribute('id');
    if (status) status.hidden = true;
    return true;
  }

  function watchFeed(section) {
    const feed = section.querySelector('[data-klampet-instagram-feed]');
    if (!feed || feed.dataset.instagramEnhanced === 'true') return;
    feed.dataset.instagramEnhanced = 'true';

    const mutationObserver = new MutationObserver(() => {
      if (!enhanceFeed(section)) return;
      mutationObserver.disconnect();
    });

    mutationObserver.observe(feed, { childList: true, subtree: true });
    window.setTimeout(() => mutationObserver.disconnect(), 15000);
  }

  function runProvider(section, attemptsRemaining = 300) {
    if (section.dataset.instagramRequested === 'true') return;

    const feed = section.querySelector('[data-klampet-instagram-feed]');
    const feedId = feed && feed.dataset.instagramFeedId;
    if (!feed || !feedId) return;

    const provider = typeof instafeedApp === 'function' ? instafeedApp : null;
    if (!provider) {
      if (attemptsRemaining > 0) {
        window.setTimeout(() => runProvider(section, attemptsRemaining - 1), 100);
      }
      return;
    }

    section.dataset.instagramRequested = 'true';
    feed.id = feedId;
    provider();
  }

  function deferFeed(section) {
    if (section.dataset.instagramObserved === 'true') return;
    section.dataset.instagramObserved = 'true';

    if (!('IntersectionObserver' in window)) {
      runProvider(section);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      runProvider(section);
    }, { rootMargin: FEED_ROOT_MARGIN, threshold: 0 });

    observer.observe(section);
  }

  function initialize(section) {
    revealSection(section);
    watchFeed(section);
    if (enhanceFeed(section)) return;
    deferFeed(section);
  }

  function initializeAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
